/* GGS product page - buy fold. v2 2026-09-24. Behaviour for
   sections/ggs-product.liquid.

   - pulls the split screen up under the fixed header (same as ggs-cart.js)
   - the stage glow eases toward the pointer (same as the cart)
   - thumbnails swap the stage image
   - variant and purchase-option (selling plan) changes update the price,
     availability and the hidden selling_plan input
   - Add to cart posts the form to /cart/add.js and then goes to /cart, so the
     next thing the shopper sees is the same stage with the same jar. If the
     add fails, Shopify's own message is shown under the button. With no
     script at all, the form still posts natively to /cart/add. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ggp]');
  if (!root) return;

  /* ---- header offset ---- */
  function setHeaderOffset() {
    var h = document.querySelector('.shopify-section-group-header-group');
    if (h) root.style.setProperty('--ggc-hdr', Math.round(h.getBoundingClientRect().height) + 'px');
  }
  setHeaderOffset();
  window.addEventListener('resize', setHeaderOffset);

  /* ---- reveal fallback: never leave anything stuck at opacity 0 ---- */
  root.querySelectorAll('.ggp-reveal').forEach(function (el) {
    el.addEventListener('animationend', function () { el.classList.add('is-in'); }, { once: true });
    var d = parseFloat(getComputedStyle(el).animationDelay) * 1000 || 0;
    setTimeout(function () { el.classList.add('is-in'); }, 900 + d);
  });

  /* ---- stage: pointer glow ---- */
  var stage = root.querySelector('[data-ggp-stage]');
  if (stage) {
    stage.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect();
      var dx = Math.max(-1, Math.min(1, (e.clientX - (r.left + r.width / 2)) / (r.width / 2)));
      var dy = Math.max(-1, Math.min(1, (e.clientY - (r.top + r.height / 2)) / (r.height / 2)));
      stage.style.setProperty('--px', dx * 24 + 'px');
      stage.style.setProperty('--py', dy * 18 + 'px');
    });
    stage.addEventListener('pointerleave', function () {
      stage.style.setProperty('--px', '0px');
      stage.style.setProperty('--py', '0px');
    });
  }

  /* ---- stage: thumbnails ---- */
  var jar = root.querySelector('[data-ggp-jar]');
  var img = root.querySelector('[data-ggp-img]');
  var thumbs = root.querySelectorAll('[data-ggp-view]');
  var cur = img ? img.getAttribute('src') : '';
  var swapTimer = null;
  thumbs.forEach(function (t) {
    var pre = new Image();
    pre.src = t.getAttribute('data-ggp-view');
  });
  function view(t) {
    if (!img || !jar) return;
    var src = t.getAttribute('data-ggp-view');
    thumbs.forEach(function (o) {
      var on = o === t;
      o.classList.toggle('is-on', on);
      o.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (!src || src === cur) return;
    cur = src;
    var isPlate = t.hasAttribute('data-plate');
    jar.classList.add('is-swapping');
    clearTimeout(swapTimer);
    swapTimer = setTimeout(function () {
      img.src = src;
      jar.classList.toggle('is-alt', !isPlate);
      jar.classList.remove('is-swapping');
    }, 260);
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { view(t); });
    t.addEventListener('mouseenter', function () { view(t); });
    t.addEventListener('focus', function () { view(t); });
  });

  /* ---- data ---- */
  var data = {};
  try {
    data = JSON.parse((root.querySelector('[data-ggp-data]') || {}).textContent || '{}');
  } catch (e) { data = {}; }
  var variants = data.variants || [];

  var form = document.getElementById('ggs-buy');
  if (!form) return;
  var vInput = form.querySelector('[data-ggp-variant]');
  var spInput = form.querySelector('[data-ggp-sp]');
  var nowEl = form.querySelector('[data-ggp-now]');
  var wasEl = form.querySelector('[data-ggp-was]');
  var stagePrice = root.querySelector('[data-ggp-stageprice]');
  var addBtn = form.querySelector('[data-ggp-add]');
  var addLabel = form.querySelector('[data-ggp-addlabel]');
  var errEl = form.querySelector('[data-ggp-err]');

  function currentVariant() {
    var id = vInput ? String(vInput.value) : '';
    for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === id) return variants[i];
    return variants[0];
  }
  function currentPlan() {
    var r = form.querySelector('input[name="ggp-plan"]:checked');
    return r ? r.value : '';
  }
  function bump(el) {
    if (!el) return;
    el.classList.remove('is-bump');
    void el.offsetWidth;
    el.classList.add('is-bump');
  }
  function refresh() {
    var v = currentVariant();
    if (!v) return;
    var plan = currentPlan();
    var p = plan && v.plans && v.plans[plan] ? v.plans[plan] : { price: v.price, compare: v.compare };

    if (spInput) {
      spInput.value = plan;
      spInput.disabled = !plan;
    }
    if (nowEl && nowEl.textContent !== p.price) { nowEl.textContent = p.price; bump(nowEl); }
    if (stagePrice) stagePrice.textContent = p.price;
    if (wasEl) {
      wasEl.textContent = p.compare || '';
      wasEl.hidden = !p.compare;
    }
    /* per-plan prices follow the selected variant */
    form.querySelectorAll('[data-ggp-planprice]').forEach(function (el) {
      var k = el.getAttribute('data-ggp-planprice');
      if (!k) el.textContent = v.price;
      else if (v.plans && v.plans[k]) el.textContent = v.plans[k].price;
    });
    if (addBtn) {
      addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? (data.addLabel || addLabel.textContent) : 'Sold out';
    }
    showError('');
  }
  form.addEventListener('change', function (e) {
    if (e.target.matches('[data-ggp-variant], input[name="ggp-plan"]')) refresh();
  });

  function showError(msg) {
    if (!errEl) return;
    errEl.textContent = msg || '';
    errEl.hidden = !msg;
  }

  /* ---- add to cart ---- */
  form.addEventListener('submit', function (e) {
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    if (addBtn) addBtn.classList.add('is-busy');
    showError('');
    var fd = new FormData(form);
    var base = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
          return j;
        });
      })
      .then(function () {
        window.location.href = base + 'cart';
      })
      .catch(function (err) {
        if (addBtn) addBtn.classList.remove('is-busy');
        showError(err.message);
      });
  });
})();
